// extracted by mini-css-extract-plugin
export default {"highlights":"destacamos-module--highlights--vORly","highlight":"destacamos-module--highlight--39rrn","arrow":"destacamos-module--arrow--EsP8k"};